/**
 * Created by Ning Jiang on 4/6/2017.
 */

import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {TimelineLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {TractorBeamLayerConfig} from "../../config/TractorBeamLayerConfig";
import {TractorBeam} from "../TractorBeam";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class IndiSymWinHighlightPresentation extends WinPresentationController {
    private gameData: TractorBeamParsedGameData;
    private _mainTl: TimelineLite | undefined;
    private GameInstance: string;

    constructor(indexes: [number, number]) {
        super(indexes, {
            name: "IndiSymWinHighlightPresentation",
            skippable: true
        })
    }

    abort() {
        if (this._mainTl) {
            this._mainTl.timeScale(4)
        }
    }

    protected startWinPresentation(): void {
        const betLineWins = <any[]>this.gameData.betWins;
        if (this._mainTl) {
            this._mainTl.progress(1);
            this._mainTl = undefined;
        }
        this._mainTl = new TimelineLite();

        betLineWins.forEach((betLineWinData, idx) => {
            let winAmtCont: PIXI.Container | undefined;
            const durr: number = this._mainTl!.duration();
            if (this._mainTl) {
                betLineWinData.winPosition.forEach((val: boolean, reelIdx: number) => {
                    if (val) {
                        const symbol = Reels.getSymbol(reelIdx, betLineWinData.betLine[reelIdx]);
                        if (symbol && this._mainTl) {
                            this._mainTl.add(this.symbolAnim(symbol),durr);
                            if (betLineWinData.winPosition.lastIndexOf(true) === reelIdx) {
                                winAmtCont = this.getWinWaysCont(betLineWinData.multipliedAmount);
                                winAmtCont.position.set(Helper.getSymbolPositions(reelIdx, betLineWinData.betLine[reelIdx])[0],
                                    Helper.getSymbolPositions(reelIdx, betLineWinData.betLine[reelIdx])[1])
                            }
                        }
                    }
                })
                this._mainTl.add(() => {
                    if (winAmtCont) {
                        StageManager.getLayer(TractorBeamLayerConfig.BIG_WIN.name).addChild(winAmtCont);
                    }
                }, durr);
            }
            if (winAmtCont && this._mainTl) {
                this._mainTl.add(() => {
                    if (winAmtCont) {
                        StageManager.getLayer(TractorBeamLayerConfig.BIG_WIN.name).removeChild(winAmtCont);
                    }
                });
            }
        });
        this._mainTl.add(() => {
            this.finish();

        })
    }

    private symbolAnim(sym:StateReelSymbol):TimelineLite{
        const tl:TimelineLite=new TimelineLite();
        tl.to(sym.scale,0.2,{
            x:1.3,
            y:1.3
        })
        tl.to(sym.scale,0.2,{
            x:1,
            y:1
        });
        tl.to(this,0.2,{});
        return tl;
    }

    protected hasWin(): boolean {
        return this.gameData.betWins.length > 0;
    }

    protected parseFeatureGameData(data: TractorBeamParsedGameData): void {
        this.gameData = data
    }

    protected stopWinPresentation(isAborted: boolean): void {
    }

    private getWinNumberText(amt: number): string {
        let str: string = Currency.formatValue(amt);
        return str;
    }

    private getWinWaysCont(amt: number): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber = new PIXI.BitmapText(this.getWinNumberText(amt), {
            fontName: "yetiCountUp",
            fontSize: 45,
        });
        while (winNumber.width > GameConfig.instance.SYMBOL_WIDTH) {
            --winNumber.fontSize;
        }
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);
        cont.addChild(winNumber);
        return cont;
    }
}
